import dayjs from "dayjs";

/**
 * Display helpers for member-search / member-profile data.
 * Upstream values often carry system prefixes or raw datetime strings; these
 * helpers keep the UI clean without mutating the underlying data.
 */

/** `"2005-07-22T17:00:00.000000"` → `"07/22/2005"`. */
export function formatDob(dob?: string | null): string {
  if (!dob) return "—";
  const d = dayjs(dob);
  return d.isValid() ? d.format("MM/DD/YYYY") : dob;
}

/** Integer years old from a DOB, or undefined if parsing fails. */
export function calcAge(dob?: string | null): number | undefined {
  if (!dob) return undefined;
  const d = dayjs(dob);
  if (!d.isValid()) return undefined;
  return dayjs().diff(d, "year");
}

/** Short gender string ("M" / "F" / raw) with a sensible fallback. */
export function formatGender(g?: string | null): string {
  if (!g) return "—";
  const s = g.trim();
  if (!s) return "—";
  const up = s.toUpperCase();
  if (up === "MALE") return "M";
  if (up === "FEMALE") return "F";
  return up;
}
